/* @section: flyn-data */
export const LOGO_URL =
  "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-08/prod_agent_ec78b061-50c1-48bf-955f-9159d0396b76/Att%20%28F%29%20Logo_8e868ba184ef4af19f9ee9e5ca784c61.jpg";

export const orgInfo = {
  name: "Future Light Youth Network",
  shortName: "FLYN",
  tagline: "Empowering Communities, Lighting the Future",
  founded: "March 15, 2018",
  foundedYear: 2018,
  type: "Youth-led Civil Society Organization (CSO)",
  director: "U Zin Ko Win",
  email: "info@flyn-mm.org",
  emailDirector: "director@flyn-mm.org",
  emailPSEA: "pseafocal@flyn-mm.org",
  address: "No. (Y/126), Ywar Ma Ward, Ywangan Township, Southern Shan State, Myanmar",
  hqCity: "Ywangan",
  branchCity: "Nyaung Shwe",
  phone: "+959 950 620 404",
  hotline: "+959 960 784 263",
  website: "www.flyn-mm.org",
};

export const missionVision = {
  mission:
    "To foster a self-sufficient and peaceful community by enhancing human resources, creating opportunities for collaboration, and providing necessary support to vulnerable groups.",
  missionMM:
    "လူသားအရင်းအမြစ်များ မြှင့်တင်ခြင်း၊ ပူးပေါင်းဆောင်ရွက်မှုအခွင့်အလမ်းများ ဖန်တီးပေးခြင်းနှင့် အားနည်းချိတ်ဆုပ်မှုရှိသောအုပ်စုများကို လိုအပ်သောပံ့ပိုးမှု ပေးခြင်းဖြင့် ကိုယ်အားကိုယ်ကိုးနိုင်ပြီး ငြိမ်းချမ်းသောလူ့အဖွဲ့အစည်းတည်ဆောက်ရန်",
  vision:
    "A thriving, inclusive, and peaceful community in Southern Shan State where every person has opportunities to lead a dignified life.",
  visionMM:
    "တောင်ရှမ်းပြည်နယ်ရှိ လူတိုင်း ဂုဏ်သိက္ခာပြည့်ဝသောဘဝကို ဦးဆောင်ရန် အခွင့်အလမ်းများရရှိသည့် ချမ်းသာကြွယ်ဝ၊ ပါဝင်မှုရှိပြီး ငြိမ်းချမ်းသောလူ့ အဖွဲ့အစည်း",
};

export const coreValues = [
  {
    title: "Youth Leadership",
    titleMM: "လူငယ်ဦးဆောင်မှု",
    description: "Harnessing the energy, innovation, and dynamism of youth to drive community change.",
    icon: "⭐",
  },
  {
    title: "Community-Based Approach",
    titleMM: "လူမှုအသိုက်အဝန်းအခြေပြု",
    description: "Building trust and acceptance through grassroots community engagement and participation.",
    icon: "🤝",
  },
  {
    title: "Inclusivity (GEDSI)",
    titleMM: "ပါဝင်မှု (GEDSI)",
    description:
      "Embracing gender equality, disability and social inclusion, including LGBTQIA+ communities.",
    icon: "🌈",
  },
  {
    title: "Transparency & Accountability",
    titleMM: "ပွင့်လင်းမြင်သာမှုနှင့် တာဝန်ခံမှု",
    description: "Maintaining the highest standards in financial management and reporting to all stakeholders.",
    icon: "🔍",
  },
  {
    title: "Conflict Sensitivity",
    titleMM: "ပဋိပက္ခ အာရုံစိုက်မှု",
    description: "Applying Do-Less-Harm (DLH) principles to navigate complex community dynamics with care.",
    icon: "☮️",
  },
  {
    title: "Proven Experience",
    titleMM: "သက်သေပြထားသော အတွေ့အကြုံ",
    description: "Delivering results in humanitarian aid and rural development across Southern Shan State.",
    icon: "🏆",
  },
];

export const impactStats = [
  { value: "2018", label: "Year Founded", suffix: "" },
  { value: "14,622", label: "Beneficiaries (2025)", suffix: "+" },
  { value: "18", label: "VSLA Villages", suffix: "" },
  { value: "8,436", label: "Earthquake Response", suffix: "+" },
  { value: "458", label: "VSLA Members", suffix: "" },
  { value: "6,186", label: "SCLR Beneficiaries", suffix: "+" },
];

export const programs = [
  {
    id: 1,
    title: "SCLR Programme",
    titleFull: "Survivor & Community-Led Response",
    titleMM: "ကပ်ဆိုး၏ ကျန်ရစ်သူများနှင့် လူမှုအသိုက်အဝန်း ဦးဆောင်တုံ့ပြန်မှု",
    period: "2023 – 2025",
    status: "Active",
    color: "primary",
    area: "Ywangan Township",
    beneficiaries: "6,186+",
    description:
      "Community-led micro-projects including concrete roads, water systems (WASH), health clinics, ECCD centers, and emergency cash/food assistance. Supporting 32 community micro-projects.",
    descriptionMM:
      "ကျောက်ခင်းလမ်း၊ ရေသန့်စင်ရေး (WASH)၊ ကျန်းမာရေးဆေးခန်း၊ ECCD စင်တာများ ပါဝင်သည့် လူမှုအသိုက်အဝန်းဦးဆောင်သောကြုမ်းပေါ်စီမံကိန်း ၃၂ ခုကို ပံ့ပိုးမှုပေးခြင်း",
    partner: "SWISSAID Myanmar / MSS",
    icon: "🌱",
  },
  {
    id: 2,
    title: "VSLA Programme",
    titleFull: "Village Savings and Loan Associations",
    titleMM: "ရွာအဆင့် စုဆောင်းငွေနှင့် ချေးငွေအသင်း",
    period: "2022 – 2024",
    status: "Completed",
    color: "accent",
    area: "Ywangan Township",
    beneficiaries: "458",
    description:
      "Established 18 Village Savings and Loan Associations (VSLAs) across 18 villages with 458 members (350 women, 108 men), strengthening economic resilience and financial inclusion.",
    descriptionMM:
      "ရွာ ၁၈ ရွာတွင် VSLA အဖွဲ့ ၁၈ ဖွဲ့ (အဖွဲ့ဝင် ၄၅၈ ဦး — အမျိုးသမီး ၃၅၀၊ အမျိုးသား ၁၀၈) ထူထောင်ပြီး စီးပွားရေးသန်မာမှုနှင့် ဘဏ္ဍာရေးပါဝင်ချောင်ပြေမှုကို မြှင့်တင်",
    partner: "SWISSAID Myanmar",
    icon: "💰",
  },
  {
    id: 3,
    title: "Earthquake Emergency Response",
    titleFull: "Inle Lake Earthquake Emergency Response",
    titleMM: "အင်းလေးကန် ငလျင်အရေးပေါ် တုံ့ပြန်မှု",
    period: "March 2025",
    status: "Completed",
    color: "destructive",
    area: "Nyaung Shwe Township",
    beneficiaries: "8,436",
    description:
      "Emergency food and non-food item distribution to 1,951 households (8,436 individuals) across 16 villages affected by the March 2025 earthquake. Including 47,970 pyi rice and 1,092 kitchen kits.",
    descriptionMM:
      "မတ်လ ၂၀၂၅ ငလျင်ကြောင့် ထိခိုက်ခဲ့သော ရွာ ၁၆ ရွာ၊ အိမ်ထောင်စု ၁,၉၅၁ (လူဦးရေ ၈,၄၃၆) သို့ အရေးပေါ်ထောက်ပံ့ရေး ပြုလုပ်ခဲ့",
    partner: "MSS / SWISSAID",
    icon: "🚨",
  },
  {
    id: 4,
    title: "HELP Project",
    titleFull: "Humanitarian Empowerment for Livelihoods & Participation",
    titleMM: "လူသားချင်းစာနာထောက်ထားမှုဖြင့် အသက်မွေးဝမ်းကျောင်းနှင့် ပါဝင်မှုဖွင့်ဟပေးရေး",
    period: "2025",
    status: "Active",
    color: "chart-3",
    area: "Nyaung Shwe Township",
    beneficiaries: "4,041",
    description:
      "Livelihoods restoration and social cohesion in earthquake-affected areas. Formation of 7 CBOs, Multi-Purpose Cash distribution (380,000 MMK per HH), and capacity building.",
    descriptionMM:
      "ငလျင်ထိခိုက်ဒေသများတွင် စီးပွားရေးဦးဆောင်မှုနှင့် လူမှုဖွဲ့စည်းမှုကို ဦးဆောင်",
    partner: "SSEQ / SWISSAID",
    icon: "🏘️",
  },
  {
    id: 5,
    title: "CARE Project",
    titleFull: "Climate-resilient Action for Resilient & Inclusive Economy",
    titleMM: "ရာသီဥတုဒဏ်ခံနိုင်ရည်ရှိသော လူကုန်ကူမှုမပါဝင်သောစီးပွားရေး",
    period: "2024 – 2025",
    status: "Active",
    color: "chart-5",
    area: "Pindaya Township",
    beneficiaries: "2,500+",
    description:
      "Climate-resilient sustainable livelihoods and inclusive economic empowerment in Pindaya Township. Focus on agricultural resilience and women economic groups.",
    descriptionMM:
      "ပင်းတယမြို့နယ်တွင် ရာသီဥတုဒဏ်ခံနိုင်ရည်ရှိသော တည်မြဲသောအသက်မွေးဝမ်းကျောင်းနှင့် ပါဝင်မှုရှိသောစီးပွားရေး",
    partner: "SWISSAID Myanmar",
    icon: "🌿",
  },
  {
    id: 6,
    title: "Colorful Hands Working Together",
    titleFull: "LGBTQIA+ Support & SRHR Programme",
    titleMM: "အတူတူလက်တွဲကာ ကန့်မပြတ် အဆင်ပြေသောဘဝ",
    period: "2022 – 2024",
    status: "Completed",
    color: "chart-4",
    area: "Pindaya & Ywangan",
    beneficiaries: "120+",
    description:
      "LGBTQIA+ peer education, sexual & reproductive health and rights (SRHR), gender-based violence awareness, and economic empowerment in partnership with UNFPA.",
    descriptionMM:
      "UNFPA နှင့်ပူးပေါင်း LGBTQIA+ ပညာပေး၊ SRHR၊ GBV အသိပညာနှင့် စီးပွားရေးဖွံ့ဖြိုး",
    partner: "UNFPA",
    icon: "🌈",
  },
];

export const partners = [
  { name: "SWISSAID Myanmar", type: "Primary Donor / Technical Partner", country: "Switzerland" },
  { name: "WaterAid", type: "WASH Programme Partner", country: "UK/Global" },
  { name: "UNFPA", type: "Health & SRHR Partner", country: "UN Agency" },
  { name: "MSS (Mothers Support Schooling)", type: "SCLR Capacity Building", country: "Germany" },
  { name: "USAID", type: "Programme Supporter", country: "USA" },
  { name: "Resilio", type: "Project Partner", country: "France" },
];

export const geographicAreas = [
  {
    name: "Ywangan Township",
    nameMM: "ငွေကွင်းမြို့နယ်",
    role: "Headquarters",
    programs: ["SCLR", "VSLA", "HELP"],
  },
  {
    name: "Pindaya Township",
    nameMM: "ပင်းတယမြို့နယ်",
    role: "Programme Area",
    programs: ["CARE", "Colorful Hands"],
  },
  {
    name: "Nyaung Shwe Township",
    nameMM: "ညောင်ရွှေမြို့နယ်",
    role: "Branch Office",
    programs: ["Earthquake Response", "HELP"],
  },
];

export const navLinks = [
  { label: "Home", labelMM: "မူလစာမျက်နှာ", path: "/" },
  { label: "About", labelMM: "အကြောင်း", path: "/about" },
  { label: "Programs", labelMM: "စီမံကိန်းများ", path: "/programs" },
  { label: "Impact", labelMM: "အကျိုးဆက်", path: "/impact" },
  { label: "Contact", labelMM: "ဆက်သွယ်ရန်", path: "/contact" },
];
